import { BlogSection } from "@/types/blog";

export const praxis: BlogSection = {
  id: "praxis",
  title: "Praxis: Körperintelligenz als Führungskompetenz",
  content: `
    <p>Körperintelligenz beginnt dort, wo wir begreifen, dass Biologie die Basis jeder Leistung ist. Selbstführung bedeutet, das eigene Nervensystem zu lesen. Aktivierung, Müdigkeit, Spannung oder Ruhe als Feedback zu begreifen.</p>
    
    <h3>Fünf Dimensionen für den Alltag</h3>
    
    <h4>1. Achtsame Selbstbeobachtung</h4>
    <p>Körpersignale sind Daten, keine Störung. Was sagt mir mein Körper gerade, und was braucht er?</p>
    <p><em>Beispiel: Sarah bemerkt mittags ein Druckgefühl im Kopf. Statt weiterzuarbeiten, geht sie 10 Minuten raus. Die Anspannung löst sich. Und nachmittags arbeitet sie fokussierter, als sie es durchgedrückt hätte.</em></p>
    
    <h4>2. Mikroentscheidungen</h4>
    <p>Kleine Pausen, bewusste Atmung, natürliche Rhythmen. Nicht große Veränderungen, sondern viele kleine Korrekturen.</p>
    <p><em>Beispiel: Ein Team-Lead etabliert die „3 Atemzüge Regel" vor jedem Meeting: Bewusst ankommen, bevor der Kopf weiterrennt.</em></p>
    
    <h4>3. Selbstmitgefühl</h4>
    <p>Präsenz statt Härte. Selbstmitgefühl reduziert messbar Cortisol und stärkt die Regenerationsfähigkeit.</p>
    <p><em>Beispiel: Statt „Ich bin so schwach" lieber „Mein Körper arbeitet gerade hart an der Heilung. Ich unterstütze ihn dabei."</em></p>
    
    <h4>4. Regeneration als Strukturprinzip</h4>
    <p>Rhythmus ist Verantwortung. Wer langfristig führen will, sich selbst oder andere, braucht strukturierte Erholung.</p>
    <p><em>Beispiel: Ein Gründer blockiert jeden Donnerstagnachmittag bewusst für „Nichts". Keine Meetings, keine Projekte. Nur Sein. Seine Kreativität steigt messbar.</em></p>
    
    <h4>5. Reflexionsfragen</h4>
    <ul>
      <li>Wo verwechsle ich Stärke mit Daueraktivität?</li>
      <li>Wann hat mein Körper zuletzt das letzte Wort gehabt?</li>
      <li>Was braucht mein System gerade: Antrieb oder Erlaubnis?</li>
    </ul>
    
    <p>Körperintelligenz ist keine Mode, sondern eine Führungskompetenz. Wahrnehmung, Feedback, Anpassung, Vertrauen. Der Unterschied: Der „Mitarbeiter" ist der eigene Organismus.</p>
    
    <blockquote>
      <p>„Gesundheit ist kein Zustand, sondern ein Beziehungsgeschehen zwischen Nervensystem, Umwelt und Kultur."</p>
      <footer>— Jörg Hörmann</footer>
    </blockquote>
  `
};
